// eslint-disable-next-line no-unused-vars
import React, { memo, useEffect, useState } from 'react';

import useFetch from 'Hooks/useFetch';
import useUser from 'Hooks/useUser';
import ReportsComponent from 'Components/Reports/Reports';
import { API_INVOICE_TOTAL_AMOUNTS } from 'Constants';

const Reports = memo(() => {
  const [totals, setTotals] = useState({});
  const [totalsLoading, setTotalsLoading] = useState(false);
  const fetcher = useFetch();
  const { data: { email, loggedIn } = {} } = useUser();

  const getTotals = () => {
    setTotalsLoading(true);

    fetcher(API_INVOICE_TOTAL_AMOUNTS)
      .then(res => setTotals(res))
      .catch(err => console.error('API_INVOICE_TOTAL_AMOUNTS', err))
      .finally(() => setTotalsLoading(false));
  };

  useEffect(() => {
    getTotals();
  }, [email, loggedIn]);

  return (
    <ReportsComponent
      totals={ totals }
      totalsLoading={ totalsLoading }
    />
  );
});

Reports.displayName = 'ReportsContainer';

export default Reports;
